export class Sistema {
    constructor(public tipo: string, public id_sistema: number, public nom_sistema: string, public nombre_usuario: string) {}
}